import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lib-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css']
})
export class CountryComponent implements OnInit {

  @Input() set code(_code: any) {
    let element = document.getElementById('_'+_code)
    if(element){
      document.querySelectorAll('.dpto').forEach(item => {
          item.classList.remove("active")
      })
      element.classList.add("active")
    }
  }
  constructor() { }

  ngOnInit(): void {

  }

}
